import { render, staticRenderFns } from "./InactivityIntervalsListPage.vue?vue&type=template&id=4951d28e&"
import script from "./InactivityIntervalsListPage.vue?vue&type=script&lang=ts&"
export * from "./InactivityIntervalsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports